import React, { useEffect } from 'react';
import {
  arrayOf, bool, func, number, oneOfType, shape, string
} from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import { usePresentation } from '../../context/PresentationProvider';
import './Filter.styles.scss';

export const Filter = ({ onChange, ratingFilters, reviewStatistics }) => {
  useEffect(() => {
    // initialize filter counts from distributions
    const { ratingDistribution, verifiedPurchaserStats } = reviewStatistics;
    ratingFilters.find((rf) => rf.id === 'verified').count = Number(verifiedPurchaserStats);
    ratingDistribution.forEach((rating) => {
      ratingFilters.find((rf) => rf.value === rating.ratingValue.toString()).count = rating.count;
    });
  }, [reviewStatistics]);
  const { useCondensedLayout } = usePresentation();

  return (
    <>
      {useCondensedLayout && <div className="ratings-reviews__review-filter-heading--mobile">Filter by:</div>}
      <div className="ratings-reviews__review-filter">
        {!useCondensedLayout && <span className="ratings-reviews__review-filter-heading">Filter by:</span>}
        {ratingFilters.map((filter, index)=> {
          const filterWrapperClasses = classNames(
            'ratings-reviews__review-filter-button-wrapper', {
              'ratings-reviews__review-filter-button-wrapper--disabled': !filter.count
            }
          );
          const filterClasses = classNames(
            'ratings-reviews__review-filter-button',
            {
              'ratings-reviews__review-filter-button__selected': filter.checked
            }
          );
          const filterPillText = useCondensedLayout ? 'Verified' : 'Verified Purchases Only';

          return (
            <div className={filterWrapperClasses} key={index}>
              <button className={filterClasses} disabled={!filter.count} onClick={() => onChange(filter.value, false)}>
              {filter.value !== 'verified' ? (
                <>
                  {filter.value}
                  <Image
                    className="ratings-reviews__review-filter-button-star"
                    src={`https://assets.thdstatic.com/images/v1/star-symbol--${!filter.count? 'grey': 'orange'}.svg`}
                    alt='star symbol'
                    lazy
                  />
                </>
              ) : filterPillText
              }

              </button>
            </div>
          )
        })}
      </div>
    </>
  );
};

Filter.displayName = 'RatingsAndReviewsFilter';

Filter.propTypes = {
  onChange: func.isRequired,
  ratingFilters: arrayOf(shape({
    checked: bool,
    id: string,
    value: oneOfType([number, string]),
    count: number
  })),
  reviewStatistics: shape({
    ratingDistribution: arrayOf(shape({
      ratingValue: number,
      count: number,
      ratingPercentage: oneOfType([number, string])
    })),
    verifiedPurchaserStats: number
  }).isRequired
};
